// extracted by mini-css-extract-plugin
export default {"foldVideoContainer":"FoldVideo_foldVideoContainer__1uqFy","foldVideo":"FoldVideo_foldVideo__2LAHg","foldGradient":"FoldVideo_foldGradient__n2K9g"};